import ThemeFeature from "./themeFeature";

class Toggler extends ThemeFeature {
    constructor(open, close, target) {
        super();
        this.open = open;
        this.close = close;
        this.target = target;
    }

    /**
     * Off-canvas
     * @param {string} openTrigger
     * @param {string} closeTrigger
     * @param {string} target
     */
    enable() {
        const eventName = 'click';
        const inView = 'in-view';

        $(this.open).on(eventName, function (e) {
            const $target = $(this).attr('href');
            $($target).addClass(inView);
            e.preventDefault();
        });

        $(this.close).on(eventName, () => {
            $(this.target).removeClass(inView);
        });
    }
}

export default Toggler;